/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { createBrowserHistory } from "history";
import { useLocation } from "react-router-dom";

import { BASENAME_URL } from "../constants/types.constant";

const useUrlParams = (params) => {
  const history = createBrowserHistory();
  const location = useLocation();

  const event = params.event !== "" ? `event=${params.event}&` : "";
  const country = params.country !== "" ? `country=${params.country}&` : "";

  const path = `${BASENAME_URL}paquetes-deportivos`;
  const search = `?${event + country}`;

  useEffect(() => {
    // Si la ruta no es igual a la url, se redirige
    if (path === window.location.pathname) {
      if (event === "" || country === "") {
        console.log("No hay parametros");
      }

      // Si ya estoy en la pagina de paquetes deportivos, no hago nada
      if (location.search !== search) {
        // Actualizo la url para evitar una recarga de la pagina
        history.push(path + search);
      }
    } else {
      // Cuando vienes de otra pagina, te redirige a la url
      if (event !== "" || country !== "") {
        console.log("Hay parametros,");
        window.location.href = path + search;
      } else if (window.location.pathname !== location.pathname) {
        history.replace({
          pathname: window.location.pathname,
        });
      } else {
        history.replace({
          pathname: `/sports${location.pathname}`,
        });
      }
    }
  }, [search]);
};

export default useUrlParams;
